import React from 'react';

import { Box } from '@chakra-ui/react';
import {
  checkAreAllQuestionsOptional,
  checkAreAllQuestionsViewOnly,
  checkIsAnswered,
  checkIsRequiredAnswered,
} from 'screens/performanceReview/helpers';
import { StyledTooltip } from 'styles/common';

import { CheckOutlined, ProgressNotStarted } from 'assets/assetsV1/iconComponents';

import { TagColored } from 'uiToolkitV1/Tag';

const ANSWER_TYPE_RESPONSE = {
  DROP_DOWN: ({ selectedAnswerOptions }) => selectedAnswerOptions[0]?.description ?? '',
  MULTI_SELECT: ({ selectedAnswerOptions }) => selectedAnswerOptions.map(({ description }) => description).join(', '),
  NONE: () => null,
  STAR_RATING: ({ selectedAnswerOptions }) => selectedAnswerOptions[0]?.displayOrder,
  NUMBER_RATING: ({ selectedAnswerOptions }) => selectedAnswerOptions[0]?.score,
};

export const getResponseText = ({ question }) => {
  const { answerType } = question;
  return ANSWER_TYPE_RESPONSE[answerType]({ ...question });
};

export const QuestionResponseStatusTag = ({
  questions,
  isValidateForm,
  showIcon = true,
  isFormFillingPage = false,
}) => {
  let color = 'black';

  // decide color - check if anything required isn't filled
  const isRequiredAnswered = checkIsRequiredAnswered({ questions });
  const isAnswered = checkIsAnswered({ questions });
  if (isValidateForm && !isRequiredAnswered) {
    color = 'red';
  }

  // decide icon - check if all applicable question input are added, whether required or not

  // eslint-disable-next-line no-nested-ternary
  const Icon = showIcon ? (isRequiredAnswered ? CheckOutlined : ProgressNotStarted) : null;

  // if multiple questions, just show answered/not answered
  let responseText = '';
  if (questions.length > 1) {
    responseText = isRequiredAnswered ? 'Answered' : 'Not Answered';
  } else {
    getResponseText({ question: questions[0] });
  }

  const areAllQuestionsViewOnly = isFormFillingPage && checkAreAllQuestionsViewOnly({ questions });
  const areAllQuestionsOptional = checkAreAllQuestionsOptional({ questions });

  if (areAllQuestionsViewOnly || areAllQuestionsOptional) {
    let responseText1 = '';
    if (areAllQuestionsViewOnly) {
      responseText1 = 'View only';
    } else {
      responseText1 = isAnswered ? responseText : 'Not answered';
    }
    return (
      <StyledTooltip title={responseText1}>
        <Box>
          <TagColored
            color="black"
            StartIcon={areAllQuestionsViewOnly && (isAnswered ? CheckOutlined : ProgressNotStarted)}
            startIconColor={isAnswered ? 'green' : 'black'}
            isCharCountTruncate
            truncateCharCount={80}
          >
            {responseText1}
          </TagColored>
        </Box>
      </StyledTooltip>
    );
  }

  return (
    <StyledTooltip title={isRequiredAnswered ? responseText : 'Not answered'}>
      <Box>
        <TagColored
          color={color}
          StartIcon={Icon}
          startIconColor={isRequiredAnswered ? 'green' : null}
          isCharCountTruncate
          truncateCharCount={80}
        >
          {isRequiredAnswered ? responseText : 'Not answered'}
        </TagColored>
      </Box>
    </StyledTooltip>
  );
};
